import { Breadcrumb } from "antd";
import React from "react";

import { BreadcrumbItem } from "../../types";

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  if (items.length === 0) return null;

  const breadcrumbItems = items.map((item) => ({
    title: item.path ? <a href={item.path}>{item.label}</a> : item.label
  }));

  return <Breadcrumb items={breadcrumbItems} className="mb-6" />;
};

export default React.memo(Breadcrumbs);
